import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JsonApiDocument } from 'dist/json-api/lib/classes/json-api-document';
import { JSON_API_URL } from 'json-api';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import {
  Router,
} from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    @Inject(JSON_API_URL) private readonly apiUrl: string,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
    @Inject(DOCUMENT) private document: any
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.isApiRequest(request)) {
      return next.handle(request).pipe(
        catchError((response: HttpErrorResponse) => {
          const document = response.error as JsonApiDocument<any>;

          if (document.errors && document.errors.length > 0) {
            const error = document.errors[0];
            if (response.status === 401 && error.code === '66') {
              const queries = new URLSearchParams(
                this.document.location.search
              );
              const currentOrigin = this.document.location.origin;
              const currentPath =
                this.document.location.pathname === '/sign-in'
                  ? '/dashboard'
                  : this.document.location.pathname;
              queries.delete('token');
              if (!queries.get('returnUrl')) {
                this.router.navigate([`/sign-in`], {
                  queryParams: {
                    returnUrl: encodeURI(
                      currentOrigin + currentPath + '?' + queries.toString()
                    ),
                  },
                });
              }
              return throwError(() => document);
            }
            this.dialog.open(ErrorDialogComponent, {
              data: error,
              position: { bottom: '24px' },
              panelClass: 'error-dialog',
              hasBackdrop: false,
            });
          }
          return throwError(() => document);
        })
      );
    }
    return next.handle(request);
  }

  private isApiRequest(request: HttpRequest<unknown>): boolean {
    return request.url.startsWith(this.apiUrl);
  }
}
